import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    count: 0,
    // backendpoint: 'https://yamyam.asia/api',
    backendpoint: 'http://localhost:8089',
    locations: null,
    location: null,
    notice: null,
    carte: null,
    domain: 'yamyam.asia',
    sidenavVisible: false,
  },
  mutations: {
    locations(state, locations) {
      state.locations = locations
    },
    location(state, location) {
      state.location = location
    },
    carte(state, carte) {
      state.carte = carte
    },
    notice(state, notice) {
      state.notice = notice
    },
  },
  actions: {
    toggleSidenav(store) {
      store.state.sidenavVisible = !store.state.sidenavVisible
    },
    closeSidenav(store) {
      store.state.sidenavVisible = false
    },
    openSidenav(store) {
      store.state.sidenavVisible = true
    },
    fetchCarte(store) {
      return new Promise((resolve, reject) => {
        fetch(store.state.backendpoint + '/carte/' + store.state.location.carte)
          .then(response => response.json(), reject)
          .then((jsonResponse) => {
            store.commit('carte', setupCarteReferrals(jsonResponse))
          }, reject)
      })
    },
    fetch(store) {
      return new Promise((resolve, reject) => {
        fetch(store.state.backendpoint + '/')
          .then(response => response.json(), reject)
          .then((jsonResponse) => {
            var locations = jsonResponse.location.available
            locations.byName = {}
            locations.byUrl = {}
            locations.byId = {}
            locations.forEach(function (location) {
              locations.byName[location.name] = location
              locations.byUrl[location.url] = location
              locations.byId[location.id] = location
            })
            var domain = document.URL.split('/')[2].split(':')[0]
            if (jsonResponse.notice && jsonResponse.notice.length > 0) {
              store.commit('notice', jsonResponse.notice[0])
            }
            // store.commit('notice', 'Liebe Kunden, \nwir nehmen heute leider keine Bestellungen zum mitnehmen mehr an.')
            store.commit('locations', locations)
            console.log(domain)
            if (domain === 'localhost' || domain.startsWith('192.168.') || domain === '127.0.0.1') {
              store.commit('location', locations.byName['offenburg'])
            } else {
              store.commit('location', locations.byId[jsonResponse.location.domainMap])
            }
            resolve()
            // if (locations.byUrl[domain]) {
            //   store.commit('location', locations.byUrl[domain])
            //   resolve()
            // } else if (domain === 'localhost' || domain.startsWith('192.168.') || domain === '127.0.0.1') {
            //   store.commit('location', locations.byName['offenburg'])
            //   resolve()
            // } else {
            //   resolve()
            //   // reject()
            // }
            // } else {
            // }
          }, reject)
      })
    },
  },
})
